const { openai } = require("../services/openai");

export const openaiAddTagsMessage = async (
  docRef,
  message,
  predefinedTags,
  type = "tags"
) => {
  const text = message;

  let systemPrompt = "";
  let userPrompt = "";

  switch (type) {
    case "tags":
      systemPrompt = `You are an AI that categorizes text based on predefined tags. Only use these tags: ${predefinedTags.join(", ")}.`;
      userPrompt = `Categorize this text: "${text}". Return an array of at least 3 relevant tags.`;
      break;
    case "categories":
      systemPrompt = `You are an AI that classifies text into exactly one of the following categories: ${predefinedTags.join(", ")}.`;
      userPrompt = `Always respond with only one category from the list, based on the most relevant theme of the text: "${text}". Return an array of at least 1 and the only one relevant category. Every message must have a category, if it doesn't have one, label it as 'undefined'`;
      break;
  }

  try {
    // Call OpenAI to categorize text
    const response = await openai.chat.completions.create({
      model: "gpt-4o",
      messages: [
        { role: "system", content: systemPrompt },
        { role: "user", content: userPrompt },
      ],
      temperature: 0.5,
    });

    console.log(response);

    // Extract tags from OpenAI response
    let tags = JSON.parse(response.choices[0].message.content);
    tags = tags.map((tag) => tag.toLowerCase())
    const validTags = tags.filter((tag) => predefinedTags.includes(tag));

    // Save tags back to Firestore
    await docRef.update({ [type]: validTags });

    console.log(`Categorized text: "${text}" as ${validTags}`);
  } catch (error) {
    console.error("Error categorizing text:", error);
  }
};

export const openaiCheckAppropriate = async (message) => {
  const text = message;

  try {
    const response = await openai.chat.completions.create({
      model: "gpt-4o",
      messages: [
        {
          role: "system",
          content:
            "You are an AI that check if the text is appropriate in public place.",
        },
        {
          role: "user",
          content: `Check this text: "${text}". Return a boolean if it's appropriate (1) or not (0).`,
        },
      ],
      temperature: 0.5,
    });

    console.log("response", response);

    return JSON.parse(response.choices[0].message.content);
  } catch (error) {
    console.error("Error appropriate text:", error);
  }
};

export const openaiGetReplyMessage = async (message) => {
  const userPrompt = message;
  const assistantId = "asst_UvMmNMuzQr5vQpaXELmqedrl";
  // const threadId = "thread_Nxta2553urmzBLjSLmGqecHK";

  try {
    const thread = await openai.beta.threads.create();
    const threadId = thread.id;

    await openai.beta.threads.messages.create(threadId, {
      role: 'user',
      content: userPrompt,
    });

    const run = await openai.beta.threads.runs.create(threadId, {
      assistant_id: assistantId,
    });
    let status;
    do {
      const runStatus = await openai.beta.threads.runs.retrieve(run.id, { thread_id: threadId });
      status = runStatus.status;
      await new Promise((r) => setTimeout(r, 1000));
    } while (status !== 'completed');

    const messages = await openai.beta.threads.messages.list(threadId);
    const message = messages.data[0];

    const cleanText = message.content[0].text.value.replace(/【[^】]*】/g, '');
    return cleanText;
  } catch (error) {
    console.error("Error replying message:", error);
  }
};
